import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { AuthService } from "./services/auth.service";
import packageJson from "../../package.json";

import { RouterLink, RouterOutlet } from "@angular/router";
import { DebugContainerComponent } from "./debug-container/debug-container.component";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, RouterOutlet, DebugContainerComponent]
})
export class AppComponent {
  private readonly authService = inject(AuthService);

  title = "prior-auth-facade";
  showLogContent = true;
  version = `FACADE V${packageJson.version}`;

  showLogs() {
    // store in session?
    this.showLogContent = !this.showLogContent;
  }

  loggedIn() {
    return this.authService.isLoggedIn();
  }

  logout() {
    this.authService.logout();
  }
}
